import tag from "../../internal/shared/graphql/tag";
/**
 * @see https://sail.stripe.me/data/api/gql
 */ export default tag;

//# sourceMappingURL=gql.js.map